<template>
  <div class="evaluation">
    <div class="top" v-if="start">
      <div class="scoreBox">
        <p class="score">
          <span>{{ start }}</span>
        </p>
        <div class="start">
          <i class="full" v-for="(item, index) in startBox[1]" :key="index"></i>
          <i class="half" v-for="(item, index) in startBox[2]" :key="index"></i>
          <i class="none" v-for="(item, index) in startBox[0]" :key="index"></i>
        </div>
        <p class="total">{{ util.showCount(evaluationTotal) }} 人评价</p>
      </div>
    </div>
    <div class="main">
      <Evaluation
        :likeType="courseType == 1000 ? '2000' : '2001'"
        :systemtime="systemtime"
        type="course"
        :evaluationList="evaluationList"
        v-on:evaluationCallback="evaluationCallback"
      ></Evaluation>
    </div>
  </div>
</template>

<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import Evaluation from "@/components/evaluation";

export default {
  props: [
    "evaluationList",
    "replaySuccessData",
    "systemtime",
    "evaluationScoreList",
    "evaluationStar",
    "evaluationTotal",
    "courseType",
  ],
  data() {
    return {
      start: "",
      startBox: [],
    };
  },
  components: {
    MescrollVue,
    Evaluation,
  },
  mounted() {
    this.start =this.evaluationTotal>0? this.evaluationStar / this.evaluationTotal:0;
    var fractionArr = this.start.toString().split(".");
    var startBox = [];
    startBox[2] = fractionArr[1] >= 5 ? 1 : 0;
    startBox[1] = fractionArr[0] - 0;
    startBox[0] = 5 - (startBox[1] + startBox[2]);
    this.startBox = startBox;
  },
  watch: {
    ["replaySuccessData"]() {
      var data = this.replaySuccessData;
      this.evaluationList[data.replayIndex].customercommentreplys.unshift(data);
    },
  },
  methods: {
    evaluationCallback(data) {
      if (data.type == "replay") {
        this.$emit("evaluationCallback", { type: "replay", data: data.data });
      } else if (data.type == "reload") {
        this.$emit("evaluationCallback", { type: "reload" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluation {
  padding: 24px 16px 0;
  .top {
    .scoreBox {
      text-align: center;
      .total {
        font-size: 11px;
        line-height: 16px;
        color: rgba(53, 54, 60, 0.4);
        font-weight: 500;
        margin-top: 8px;
      }
      .start {
        margin-top: 12px;
        i {
          display: inline-block;
          width: 16px;
          height: 16px;
        }
        i.full {
          background: url(../../../../assets/img/h5/fraction_full_b.png) no-repeat;
          background-size: 16px 16px;
        }
        i.half {
          background: url(../../../../assets/img/h5/fraction_half_b.png) no-repeat;
          background-size: 16px 16px;
        }
        i.none {
          background: url(../../../../assets/img/h5/fraction_none_b.png) no-repeat;
          background-size: 16px 16px;
        }
        i:not(:last-child) {
          margin-right: 3px;
        }
      }
      .score {
        span {
          font-size: 28px;
          line-height: 36px;
          color: rgba(53, 54, 60, 1);
          font-weight: bold;
        }
      }
    }
  }
  .main {
    margin-top: 24px;
  }
}
</style>